import axios from 'axios';

require('dotenv/config');

export const UserApi = axios.create({
  baseURL: `${process.env.VUE_APP_USERS_BACKEND_URL}/users`,
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token, X-Custom-Information'
  }
});

export const OfferApi = axios.create({
  baseURL: `${process.env.VUE_APP_OFFERS_BACKEND_URL}/offers`,
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token, X-Custom-Information'
  },
  paramsSerializer: params => Qs.stringify(params, { arrayFormat: 'repeat' })
});

export const AnnouncementApi = axios.create({
  baseURL: `${process.env.VUE_APP_REVATECH_BACKEND_URL}/announcements`,
  headers: {
    'Content-Type': 'application/json'
  }
});

export const MailSettingsApi = axios.create({
  baseURL: `${process.env.VUE_APP_REVATECH_BACKEND_URL}/mail-settings`,
  headers: {
    'Content-Type': 'application/json'
  }
});

export const ProductApi = axios.create({
  baseURL: `${process.env.VUE_APP_PRODUCTS_BACKEND_URL}/products`,
  headers: {
    'Content-Type': 'application/json'
  }
});
